import Vue from 'vue/dist/vue.esm'

Vue.component(
  'boletines-judiciales-vue',
  () => import(/* webpackChunkName: "[request]" */ 'components/BoletinesJudiciales')
)
